const staticAtlasPageUrls = import.meta.glob(
  '../../assets/baked/statics/*.webp',
  { eager: true, query: '?url', import: 'default' },
) as Record<string, string>;

/** Resolve one generated statics page basename to its Vite asset URL. */
export function staticAtlasPageUrl(atlas: string): string | undefined {
  const suffix = `/${atlas}`;
  const entry = Object.entries(staticAtlasPageUrls)
    .find(([path]) => path.endsWith(suffix));
  return entry?.[1];
}
